'use client';

import React from 'react';
import { StrategyListGenerator } from '../index';
import { LOCATION } from 'src/hooks/filters/constants';
import { StrategyConfigProps } from 'src/components/Strategy/config';

const ScoutListConfiguration: React.FC<StrategyConfigProps> = ({
  location = LOCATION.STRATEGY,
}) => {
  return <StrategyListGenerator strategyType="SCOUT_LIST" location={location} />;
};

export default ScoutListConfiguration;
